interface LoadingStateProps {
  displayValue: number;
  className?: string;
}

const getDisplayColor = (displayValue: number) => {
  if (displayValue < 4) return "#2A424B";
  if (displayValue < 26) return "#0F808E";
  if (displayValue < 38) return "#1D3D71";
  if (displayValue < 54) return "#09795E";
  if (displayValue < 76) return "#54BC7D";
  return "#677288";
};

const LoadingState: React.FC<LoadingStateProps> = ({
  displayValue,
  className = "",
}) => {
  const displayColor = getDisplayColor(displayValue);

  return (
    <div
      className={`flex w-full items-center justify-center rounded-box bg-white p-4 ${className}`}
      role="status"
      aria-live="polite"
      style={{color: displayColor}}>
      <div className="flex items-center justify-center gap-3 text-[22px] font-medium">
        <span
          className="h-6 w-6 animate-spin rounded-full border-[3px] border-current border-r-transparent"
          aria-hidden="true"
        />
        <span>Loading...</span>
      </div>
    </div>
  );
};

export default LoadingState;
